// src/constants/version.ts

export const APP_VERSION = "0.1.1";
export const GENERATOR_VERSION = "y3-subtraction-v1";